import { useContext } from "react";
import { Box } from "@mui/material";
import { ParagraphText } from "../../../../../Libraries";
import moment from "moment";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { ImgPlaceHolder, RupinFavIcon } from "../../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import styles from "../../TransactionListing/TransactionListing.module.css";
import { LanguageContext } from "../../../../../context/LanguageContext";

const getTypeLabel = (type, I18n) => {
  if (!type) return "-";
  const key = String(type).toLowerCase();
  const TYPE_LABELS = {
    easyload: I18n.easyload,
    package: I18n.package,
    prepaid: I18n.prepaid,
    postpaid: I18n.postpaid,
  };
  return TYPE_LABELS[key] || type.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
};

const EasyloadTransactionRow = ({ item, hideContact = false, onAddContact, onRowClick }) => {
  const [I18n] = useContext(LanguageContext);
  const colClass = hideContact ? "fourColumn" : "fiveColumn";
  const {
    created_at,
    telco_display_name,
    bill_company,
    logo_link,
    txn_sub_type,
    customer_phone_masked,
    customer,
    consumer_number,
    customer_phone,
    customer_name,
    amount,
    mode,
    type
  } = item || {};
  const isCashback = mode === "credit";
  const companyName = telco_display_name || bill_company || "-";
  const phone = customer || customer_phone_masked || consumer_number || customer_phone || "";


  const typeLabel = type === 'bundle_recharge' ? I18n.package : I18n.easyload;

  return (
    <Box
      id={`easyload_transaction_row_${item?.id}`}
      className={`invoiceListTableBody accountTableHeaderMain${!isCashback ? " pointer" : ""}`}
      onClick={
        !isCashback
          ? () => {
            triggerLogEvent(analytics, "w_easyload_txn_row_click");
            onRowClick?.(item);
          }
          : undefined
      }
    >
      {/* Date */}
      <Box className={`invListTableHeaderCol ${colClass} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 newLightColor">
          {created_at ? moment(created_at).format("DD MMM YYYY") : "-"}
        </ParagraphText>
      </Box>

      {/* Company — cashback always shows RUPIN, recharge shows the telco */}
      <Box className={`invListTableHeaderCol ${colClass} textLeft ${styles.contactCell} ${styles.favIconBox}`}>
        {isCashback ? (
          <Box className={styles.companyLogoFallback}>
            <RupinFavIcon width={20} height={20} />
          </Box>
        ) : logo_link ? (
          <img
            src={logo_link}
            alt={companyName}
            className={styles.companyLogo}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : (
          <Box className={styles.companyLogoFallback}>
            <ImgPlaceHolder width={20} height={20} />
          </Box>
        )}
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine newFontColor">
          {isCashback ? "RUPIN" : companyName}
        </ParagraphText>
      </Box>

      {/* Type */}
      <Box className={`invListTableHeaderCol ${colClass} textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {txn_sub_type ? getTypeLabel(txn_sub_type, I18n) : isCashback ? I18n.cashback : typeLabel}
        </ParagraphText>
      </Box>

      {/* Contact — cashback shows name/phone only; recharge offers "Add contact" when unlinked.
          Hidden entirely in a specific contact's detail view since it would just repeat that contact. */}
      {!hideContact && (
        <Box className="invListTableHeaderCol fiveColumn textLeft">
          {isCashback ? (
            <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
              {[customer_name, phone].filter(Boolean).join(" • ") || "-"}
            </ParagraphText>
          ) : (
            <ParagraphText className="fontSize14 fontWeight400 newFontColor displayFlex alignCenter truncateOneLine" style={{ gap: 4 }}>
              {customer_name ? (
                <span>{customer_name}</span>
              ) : (
                <span
                  id={`easyload_transaction_add_contact_link_${item?.id}`}
                  className="newFontColor textDecorationUnerline pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    triggerLogEvent(analytics, "w_easyload_txn_add_contact");
                    onAddContact?.(item);
                  }}
                >
                  {I18n.add_contact}
                </span>
              )}
              {phone ? (
                <>
                  <span className="newFontColor">&nbsp;&bull;&nbsp;</span>
                  <span>{phone}</span>
                </>
              ) : null}
            </ParagraphText>
          )}
        </Box>
      )}

      {/* Amount */}
      <Box className={`invListTableHeaderCol ${colClass} textRight`}>
        <ParagraphText
          className={`fontSize14 fontWeight400 ${isCashback ? styles.creditAmount : styles.debitAmount}`}
        >
          {isCashback ? "+" : "-"}Rs. {formatNum(Math.abs(amount || 0))}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default EasyloadTransactionRow;
